const UserManagementActivityLog = ({
    changedUserId = '',
    reverseCreatedMs = '',
    changedByUserType = '',
    changedByUserId = '',
    activityType = '',
    oldValue = '',
    newValue = '',
    created = '',
    changedUserEmail = '',
}) => ({
    changedUserId: String(changedUserId),
    reverseCreatedMs: String(reverseCreatedMs),
    changedByUserType: String(changedByUserType),
    changedByUserId: String(changedByUserId),
    activityType: String(activityType),
    oldValue: String(oldValue),
    newValue: String(newValue),
    created: String(created),
    changedUserEmail: String(changedUserEmail),
});

export default UserManagementActivityLog;
